export { config } from './config'
export { initChiefSlider } from './initChiefSlider'
export { getDateRestriction } from './libs'
export { Slide, SlidesCarousel } from './ui'


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/index.jsx